var _excluded = ["code", "children"],
    _excluded2 = ["code", "children"];

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React, { Children } from 'react';
import { uniq } from 'lodash';
import { useAccess } from '@foody/common';
import { deepMap } from './reactChildren';
import Tooltip from './Tooltip';
/**
 * @description 1.仅在有权限时展示; 2. 组件具有Tooltip
 * @description 嵌套使用时,access code 会累加
 */
// AccessCodes为权限枚举类型，需由外部传入

export var AccessConsumer = function AccessConsumer(props) {
  var children = props.children,
      code = props.code;
  var isAuth = useAccess(code);

  if (typeof children === 'function') {
    return children(isAuth);
  }

  return null;
}; // permissions toast 展示条件

var EffectiveInspection = {
  htmlType: 'button'
}; // 校验props是否满足条件

var verifyPropsFieldValue = function verifyPropsFieldValue(node) {
  if (!node || !node.props) return false;
  var props = node.props;
  var keys = Object.keys(EffectiveInspection);
  return keys.some(function (item) {
    return props[item] === EffectiveInspection[item];
  });
};

var setNewElement = function setNewElement(element) {
  var elementProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var extraProps = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  return /*#__PURE__*/React.cloneElement(element, _objectSpread(_objectSpread({}, elementProps), extraProps));
}; // AccessCodes为权限枚举类型，需由外部传入


export default function (props) {
  var code = props.code,
      children = props.children,
      restProps = _objectWithoutProperties(props, _excluded);

  var target = function target() {
    return deepMap(children, function (child) {
      var _child$props;

      var isAccessTooltip = !!(child.props && child.props.title && child.props.placement);
      var isBasicReactDom = child && verifyPropsFieldValue(child) && !((_child$props = child.props) === null || _child$props === void 0 ? void 0 : _child$props.hasaccessonlyintarget);

      if (isAccessTooltip) {
        // child 具备 tooltip的属性
        var _child$props2 = child.props,
            title = _child$props2.title,
            hasaccessonlyintarget = _child$props2.hasaccessonlyintarget;

        if (useAccess(title) && hasaccessonlyintarget) {
          return setNewElement(child, child.props, {
            // access code 累积
            title: uniq(([title, code] || []).flat(Infinity)) || '',
            key: child.key || ''
          });
        }
      }

      if (isBasicReactDom) {
        var _child$props3 = child.props,
            _child$props3$disable = _child$props3.disabled,
            disabled = _child$props3$disable === void 0 ? false : _child$props3$disable,
            _child$props3$style = _child$props3.style,
            style = _child$props3$style === void 0 ? {} : _child$props3$style;
        var newStyle = disabled ? {
          pointerEvents: 'none'
        } : {};
        var renderChild = /*#__PURE__*/React.createElement(Tooltip, {
          title: code,
          placement: "top"
        }, setNewElement(child, child.props, {
          // antd: disable 元素使用tooltip,mouseleave 无法正常工作
          style: _objectSpread(_objectSpread({}, style), newStyle),
          hasaccessonlyintarget: '1',
          key: child.key || ''
        }));
        return setNewElement(renderChild, restProps, {
          key: child.key || ''
        });
      }

      return child;
    });
  };

  return /*#__PURE__*/React.createElement(AccessConsumer, {
    code: code
  }, function (isAuth) {
    return isAuth ? target() : null;
  });
} // 无权限时，给表单加上 disabled 的 props

export var AccessFormItem = function AccessFormItem(props) {
  var code = props.code,
      children = props.children,
      rest = _objectWithoutProperties(props, _excluded2);

  return /*#__PURE__*/React.createElement(AccessConsumer, {
    code: code
  }, function (isAuth) {
    return Children.map(children, function (item) {
      return /*#__PURE__*/React.cloneElement(item, _objectSpread({
        disabled: !isAuth || item.props.disabled
      }, rest));
    });
  });
};